import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  listSeatEmployee: [],

};

export const getters = {
  listSeatEmployee: state => state.listSeatEmployee,
};

export const mutations = {
  [types.SEAT_EMPLOYEE.LIST_SEAT_EMPLOYEE](state, data) {
    state.listSeatEmployee = data;
  }
};

export const actions = {
  async listSeatEmployee({ commit }, floor) {
    let url = `${api.LIST_SEAT_EMPLOYEE}?floor=${floor}`
    const response = await axios.get(url);
    commit(types.SEAT_EMPLOYEE.LIST_SEAT_EMPLOYEE, response.data);
  }
};
